import Dropdown from 'flarum/common/components/Dropdown';
import Icon from 'flarum/common/components/Icon';
export default class MoreDropdown extends Dropdown {
  static initAttrs(attrs) {
    attrs.className ||= 'MoreDropdown';
    attrs.buttonClassName ||= 'Button Button--flat hasIcon';
    attrs.icon ||= 'fas fa-ellipsis-h';
    super.initAttrs(attrs);
  }
  getMenu(items) {
    return m("ul", {
      className: 'Dropdown-menu dropdown-menu ' + this.attrs.menuClassName,
      onclick: this.menuClick.bind(this)
    }, items);
  }
  getButtonContent(children) {
    return [this.attrs.icon ? m(Icon, {
      name: this.attrs.icon,
      className: "Button-icon"
    }) : '', m("span", {
      className: "Button-label"
    }, this.attrs.label)];
  }
  menuClick(e) {
    // Do nothing if the menu itself is clicked
    if (e.target == e.currentTarget) return;
    const clickedItem = e.target;
    const id = Array.from(clickedItem.closest('li').classList).find(value => value.startsWith('item'));
    const parentContainer = this.element.closest('.Header-controls');
    const target = parentContainer.querySelector(`:scope > .${id}`);
    const toBeClicked = target.querySelector('a, button');

    // @ts-ignore
    this.attrs.parent.helper.clearChoiceItem();
    if (toBeClicked.tagName == 'BUTTON') {
      target.classList.remove('hidden-item');
      target.classList.add('chosen-item');
    }

    // @ts-ignore
    this.attrs.parent.helper.layout();
    setTimeout(() => toBeClicked.click(), 0);
  }
}
flarum.reg.add('dalez-fluent-flarum', 'forum/globalHeader/moreDropdown', MoreDropdown);